import {
    axios
} from '@/utils/request'

const list = (parameter) => {
    return axios({
        url: '/role/list',
        method: 'post',
        data: parameter
    })
}
const add = (parameter) => {
    return axios({
        url: '/role',
        method: 'post',
        data: parameter
    })
}
const update = (parameter) => {
    return axios({
        url: '/role',
        method: 'PUT',
        data: parameter
    })
}
const del = (parameter) => {
    return axios({
        url: '/role',
        method: 'delete',
        params: parameter
    })
}
const auth = (parameter) => {
    return axios({
        url: '/permission',
        method: 'get',
        params: parameter
    })
}
const detail = (parameter) => {
    return axios({
        url: '/role',
        method: 'get',
        params: parameter
    })
}
export {
    list,
    add,
    update,
    del,
    detail,
    auth
}
